/**
 * Thin wrapper around the shared ui-kit agent widget.
 *
 * The widget itself lives at `@isg/ui-kit/js/components/agent-widget.js`
 * so every ISG app mounts the same implementation. This file supplies
 * the helpdesk-specific prompts and labels, then delegates.
 */
import { renderAgentWidget } from '@isg/ui-kit';
import { t } from '../i18n/index.js';

// Built at render time (never at module scope) so the prompts follow the
// reader's locale.
function suggestions() {
  return [
    t('assistant.suggestion.sla_breaches'),
    t('assistant.suggestion.unassigned_urgent'),
    t('assistant.suggestion.lightest_workload'),
    t('assistant.suggestion.summarise_queue'),
    t('assistant.suggestion.search_vpn'),
  ];
}

export function renderAIAssistant(container) {
  renderAgentWidget(container, {
    appSlug: 'helpdesk',
    title: t('assistant.title'),
    placeholder: t('assistant.placeholder'),
    suggestions: suggestions(),
  });
}
